import { Dispatch } from "redux";
import {
  UserAuthActionTypes,
  userLoginFailure,
  userLoginSuccess,
} from "../store/actions/userAuthActions";
import { signIn, logout as logoutApi } from "../apis/dealer";

export const UserAuthService = {
  login: async (
    email: string,
    password: string,
    dispatch: Dispatch<UserAuthActionTypes>
  ) => {
    try {
      const res = await signIn({ email: email, password: password })
      if (res?.error) {
        dispatch(userLoginFailure(res?.error));
      }
      if (res?.access_token) {
        localStorage.setItem("user_access_token", res.access_token);
        if (res.refresh_token) {
          localStorage.setItem("user_refresh_token", res.refresh_token);
        }
        if (res.expires_in) {
          const expiresAt = Date.now() + res.expires_in * 1000;
          localStorage.setItem("user_token_expires_at", String(expiresAt));
        }
        dispatch(userLoginSuccess(res.access_token));
        return true;
      }
    } catch (error: any) {
      // Dispatch login failure action
      dispatch(userLoginFailure(error.message));
    }
  },

  logout: async (dispatch: Dispatch<UserAuthActionTypes>) => {
    // Call backend to blacklist the token before clearing
    try {
      await logoutApi();
    } catch (err) {
      // Proceed with local logout even if backend call fails
    }
    // Clear tokens from localStorage on logout
    localStorage.removeItem("user_access_token");
    localStorage.removeItem("user_refresh_token");
    localStorage.removeItem("user_token_expires_at");
  },

  getToken: () => {
    // Retrieve token from localStorage
    return localStorage.getItem("user_access_token");
  },

  isAuthenticated: () => {
    // Check if token exists in localStorage
    return !!localStorage.getItem("user_access_token");
  },
};
